export default function () {
  'ngInject';

  return text => text ? text.replace(/\n/g, '<br>') : null;
}
